function normalizeOpt(item) {
    if (item == null) return null;
    if (typeof item === 'string' || typeof item === 'number') {
        return { value: String(item), label: String(item) };
    }
    if (typeof item === 'object') {
        const value = item.value ?? item.id ?? item.ratio ?? item.name;
        if (value == null || value === '') return null;
        return { value: String(value), label: String(item.label ?? item.name ?? value) };
    }
    return null;
}

export function paramSpec(params, key) {
    if (!params || typeof params !== 'object') return null;
    const nested = params.parameters;
    if (nested && typeof nested === 'object' && nested[key] != null) {
        return nested[key];
    }
    return params[key] ?? null;
}

export function paramOptions(params, key) {
    const spec = paramSpec(params, key);
    if (!spec) return [];
    if (Array.isArray(spec)) return spec.map(normalizeOpt).filter(Boolean);
    const raw = spec.values || spec.enum || spec.options || spec.voices;
    if (!Array.isArray(raw)) return [];
    return raw.map(normalizeOpt).filter(Boolean);
}

export function paramDefault(params, key, fallback = '') {
    const spec = paramSpec(params, key);
    if (spec && typeof spec === 'object' && !Array.isArray(spec) && spec.default != null) {
        return String(spec.default);
    }
    const opts = paramOptions(params, key);
    return opts[0]?.value ?? fallback;
}

export function audioKind(model) {
    return String(model?.audio_kind || '').toLowerCase();
}

export function isSpeechToText(model) {
    const kind = audioKind(model);
    if (kind === 'stt') return true;
    const caps = model?.capabilities || {};
    return Boolean(caps.speech_to_text || caps.audio_to_text);
}

export function modelHasAudioOut(model) {
    const kind = audioKind(model);
    if (kind === 'tts' || kind === 'music') return true;
    const caps = model?.capabilities || {};
    return Boolean(caps.text_to_speech || caps.text_to_music || caps.text_to_audio);
}
